import withAdUnitPath from "../withAdUnitPath";
import Advert from "../../components/Advert";
import floorSelector from "./floorSelector";

export default withAdUnitPath(Advert, {
  pageType: "CATEGORY",
  floorSelector
});
